import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CircularProgress from '@mui/material/CircularProgress';
import './demo.css';
import AppNavBar from '../../helper/appbar';
import { useLocation } from 'react-router-dom';

const DemoPage = () => {
    const { state } = useLocation();
    const [submitStatus, setSubmitStatus] = useState({ sign: "Submit", isLoading: false });

    const submitForm = (event) => {
        event.preventDefault();
        setSubmitStatus({ sign: "", isLoading: true });
        setTimeout(() => {
            setSubmitStatus({ sign: "Submitted", isLoading: false });
        }, 6000);
    };

    const email = state?.email || "";
    return (
        <main>
            <AppNavBar navType={"dark"} />
            <section className='demo_main_section'>
                <Container>
                    <Row>
                        <Col sm={12} lg={6}>
                            <h1>Request Demo Form</h1>
                            <ul>
                                <li>Fill out the form</li>
                                <li>You will be contacted</li>
                                <li>Get a personalized product walkthrough</li>
                            </ul>
                        </Col>
                        <Col sm={12} lg={6}>
                            <form onSubmit={submitForm}>
                                <input placeholder='First name' />
                                <input placeholder='Last name' />
                                <input placeholder='Country' />
                                <input placeholder='Phone number' />
                                <input placeholder='Work email' defaultValue={email || ""} />
                                <input placeholder='Company name' />
                                <input placeholder='Number of employees' />
                                <button disabled={submitStatus.sign === "Submitted"}>
                                    {submitStatus.isLoading ?
                                        <CircularProgress
                                            size={30}
                                            sx={{ marginTop: 1 }}
                                        />
                                        :
                                        submitStatus.sign
                                    }
                                </button>
                            </form>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
};

export default DemoPage;